"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _tooltip = _interopRequireDefault(require("@ux/tooltip"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _ConditionalAnchor = require("./ConditionalAnchor");
var _TooltipWrapper = require("./styles/TooltipWrapper");
var _utils = require("@site/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable complexity */

const TooltipWrapper = ({
  title,
  tooltipContent,
  id,
  tooltipLabelText,
  open = false,
  classNames = {},
  tooltipButtonText,
  tooltipButtonAriaLabel,
  stopPropagation = false,
  dataEid,
  dataTestId,
  dataCy,
  openOnHover,
  onOpen,
  hideClose,
  customClose,
  autoHideTimeout,
  autoHideTimerHandle = null,
  videoUrl,
  imageUrl,
  backgroundColor,
  linkUrl,
  portalElem
}) => {
  const {
    messages,
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const [show, setShow] = (0, _react.useState)(open);
  const anchorRef = (0, _react.useRef)(null);
  const onTooltipButtonClick = event => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (!show) {
      onOpen?.();
    }
    setShow(!show);
    dataEid && (0, _utils.logEvent)({
      eid: dataEid,
      type: 'click',
      properties: {}
    });
  };
  const onTooltipCloseButtonClick = () => {
    customClose ? customClose() : setShow(false);
  };
  const stopAutoHideTimer = () => {
    if (autoHideTimerHandle) {
      clearTimeout(autoHideTimerHandle);
    }
  };
  const onTooltipButtonMouseEnter = () => {
    if (openOnHover) {
      !show && setShow(true);
      stopAutoHideTimer();
      onOpen?.();
    }
  };
  const startAutoHideTimer = () => {
    if (!autoHideTimeout) return;
    stopAutoHideTimer();
    autoHideTimerHandle = setTimeout(setShow, autoHideTimeout, false);
  };
  const onTooltipButtonMouseLeave = () => {
    startAutoHideTimer();
  };
  const translatedId = messages[id] ? formatMessage({
    id
  }) : id;
  const icons = {
    help: /*#__PURE__*/_react.default.createElement(_help.default, {
      height: 16,
      width: 16,
      role: "presentation"
    }),
    x: /*#__PURE__*/_react.default.createElement(_x.default, {
      height: "1.5rem",
      width: "1.5rem",
      role: "presentation"
    })
  };
  return tooltipContent && id ? /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipWrap, {
    className: `${classNames.tooltipWrapper}`,
    "data-cy": dataCy || 'tooltip-wrap',
    "data-testid": "tooltip-wrap",
    backgroundColor: backgroundColor
  }, tooltipLabelText && /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "tooltip-label",
    "data-testid": "tooltip-label"
  }, messages[tooltipLabelText] ? formatMessage({
    id: tooltipLabelText
  }) : tooltipLabelText), /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipButton, {
    ref: anchorRef,
    onMouseEnter: onTooltipButtonMouseEnter,
    onMouseLeave: onTooltipButtonMouseLeave,
    onClick: onTooltipButtonClick,
    "data-testid": dataTestId || id,
    "data-cy": "tooltip-button",
    "aria-describedby": translatedId,
    "aria-label": tooltipButtonAriaLabel || formatMessage({
      id: 'ariaLabelOpenTooltip'
    }),
    className: `${classNames.tooltipButton}`
  }, tooltipButtonText ? tooltipButtonText : icons.help), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    anchorRef: anchorRef,
    id: translatedId,
    "data-testid": "tooltip-test-id",
    open: show || open,
    onClose: () => setShow(false),
    portalElem: portalElem
  }, /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipContainer, {
    "data-cy": "tooltip-inner",
    "data-testid": "tooltip-inner"
  }, (videoUrl || imageUrl) && /*#__PURE__*/_react.default.createElement(_TooltipWrapper.MediaWrapper, null, videoUrl && /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipVideo, {
    "data-testid": "tooltip-video",
    src: videoUrl,
    width: _TooltipWrapper.tooltipMediaWidth,
    height: _TooltipWrapper.tooltipMediaHeight,
    autoplay: true,
    muted: true,
    controls: true
  }), imageUrl && !videoUrl && /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipImage, {
    "data-testid": "tooltip-image",
    src: imageUrl
  })), title && /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TitleWrapper, {
    className: `${classNames.tooltipTitle}`,
    "data-testid": "tooltip-title"
  }, title), !hideClose && /*#__PURE__*/_react.default.createElement(_TooltipWrapper.TooltipCloseButton, {
    "aria-label": "Close Tooltip",
    onClick: onTooltipCloseButtonClick,
    "data-cy": "tooltip-close-button",
    "data-testid": "tooltip-close-button",
    small: !!(imageUrl || videoUrl)
  }, icons.x), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classNames.tooltipContent, {
      'mt-4': !title && !hideClose
    }),
    "data-cy": "tooltip-content",
    "data-testid": "tooltip-content"
  }, /*#__PURE__*/_react.default.createElement(_ConditionalAnchor.ConditionalAnchor, {
    dataTestid: "tooltip-link",
    linkUrl: linkUrl,
    underlined: false
  }, typeof tooltipContent === 'string' ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _utils.sanitizeHTML)(tooltipContent)
    }
  }) : tooltipContent))))) : null;
};
exports.TooltipWrapper = TooltipWrapper;
TooltipWrapper.propTypes = {
  id: _propTypes.default.string.isRequired,
  tooltipContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]),
  tooltipLabelText: _propTypes.default.string,
  dataEid: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  tooltipButtonText: _propTypes.default.node,
  tooltipButtonAriaLabel: _propTypes.default.string,
  stopPropagation: _propTypes.default.bool,
  openOnHover: _propTypes.default.bool,
  open: _propTypes.default.bool,
  autoHideTimeout: _propTypes.default.number,
  onOpen: _propTypes.default.func,
  customClose: _propTypes.default.func,
  hideClose: _propTypes.default.bool,
  autoHideTimerHandle: _propTypes.default.func,
  classNames: _propTypes.default.shape({
    tooltipWrapper: _propTypes.default.string,
    tooltipButton: _propTypes.default.string,
    tooltipTitle: _propTypes.default.string,
    tooltipContent: _propTypes.default.string
  }),
  backgroundColor: _propTypes.default.string,
  videoUrl: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  linkUrl: _propTypes.default.string,
  portalElem: _propTypes.default.object
};